import { useState } from 'react';
import { X } from '@phosphor-icons/react';

const IN_APP_PATTERNS = [
  /FBAN/i, /FBAV/i,         // Facebook
  /Instagram/i,              // Instagram
  /WhatsApp/i,               // WhatsApp
  /GSA\//i,                  // Gmail (Google Search App)
  /LinkedIn/i,               // LinkedIn
];

function isInAppBrowser() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return IN_APP_PATTERNS.some(p => p.test(ua));
}

function isPWA() {
  if (typeof window === 'undefined') return false;
  return window.matchMedia('(display-mode: standalone)').matches
    || (navigator as any).standalone === true;
}

export default function InAppBrowserBanner() {
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem('ft_iab_dismissed') === '1'; } catch { return false; }
  });

  if (dismissed || !isInAppBrowser() || isPWA()) return null;

  const dismiss = () => {
    setDismissed(true);
    try { sessionStorage.setItem('ft_iab_dismissed', '1'); } catch {}
  };

  return (
    <div className="bg-[#1B4332] text-white px-4 py-2.5 flex items-start gap-3 text-xs" data-testid="in-app-browser-banner">
      <div className="flex-1">
        <p className="font-semibold mb-1">For the best experience, open in Safari or Chrome, or add Fore Tour to your home screen</p>
        <a href={window.location.href} target="_blank" rel="noopener noreferrer"
          className="inline-block px-3 py-1 bg-white/20 rounded-lg font-semibold text-[11px] mt-0.5"
          data-testid="open-in-browser-btn">
          Open in browser
        </a>
      </div>
      <button onClick={dismiss} className="p-1 -mr-1 -mt-0.5 flex-shrink-0" data-testid="dismiss-iab-banner">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
